import React from 'react';

interface StarRatingProps {
  value: number;
  maxStars?: number;
}

export const StarRating: React.FC<StarRatingProps> = ({ value, maxStars = 5 }) => {
  const numericValue = typeof value === 'number' ? value : parseFloat(String(value));
  
  if (isNaN(numericValue)) {
    return <span>{value}</span>;
  }

  const clampedValue = Math.max(0, Math.min(maxStars, numericValue));
  const fullStars = Math.floor(clampedValue);
  const partialFill = clampedValue % 1;
  const hasPartialStar = partialFill > 0;
  const emptyStars = maxStars - fullStars - (hasPartialStar ? 1 : 0);

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium" style={{ minWidth: '32px' }}>
        {numericValue.toFixed(1)}
      </span>
      <div className="flex items-center gap-0.5">
        {[...Array(fullStars)].map((_, i) => (
          <svg
            key={`full-${i}`}
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="#FDB022"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
          </svg>
        ))}
        {hasPartialStar && (
          <svg
            key="partial"
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id={`partial-fill-${numericValue}`}>
                <stop offset={`${partialFill * 100}%`} stopColor="#FDB022" />
                <stop offset={`${partialFill * 100}%`} stopColor="#E5E7EB" />
              </linearGradient>
            </defs>
            <path
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              fill={`url(#partial-fill-${numericValue})`}
            />
          </svg>
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <svg
            key={`empty-${i}`}
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="#E5E7EB"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
          </svg>
        ))}
      </div>
    </div>
  );
};
